import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmailMessagesListComponent } from './email-messages-list/email-messages-list.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: EmailMessagesListComponent,
        data: {
          title: 'Email Messages'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmailMessagesRoutingModule {
}
